/**
 * Created by hernanherreros on 2019-06-27
 */

import * as React from 'react'
import styled from 'styled-components'
import { i18n } from '../../../providers/Locale/localeProvider'
import { capitalize } from '../../../helpers/general'
import { Modal, Timeline } from 'antd'
import moment from 'moment'
import { fontSize, FontSizeProps } from 'styled-system'
import { Trans } from '@lingui/macro'
import SpeakerBadge from './SpeakerBadge'
import DefaultAvatar from '../static/defaultAvatar.png'

interface Props {
  isOpen: boolean;
  data: any;
  subActivities: any[];
  speakers: any[];
  onClose: () => void;
  customRender?: () => React.ReactNode;
}

interface State {
}

export default class ActivityDetailModal extends React.Component<Props, State> {
  render() {
    const { isOpen, data, subActivities, onClose, speakers } = this.props

    const startHour = new Date(data.StartsAt).toLocaleTimeString('es-CL').substring(0, 5)
    const endHour = new Date(data.EndsAt).toLocaleTimeString('es-CL').substring(0, 5)

    const momentDate = moment(data.StartsAt).locale(i18n.language)

    const date = `${capitalize(momentDate.format('dddd'))} ${momentDate.format('LL')}`

    return (
      <Modal
        title={i18n._('Detalle de la actividad')}
        visible={isOpen}
        onCancel={onClose}
        width={900}
        footer={null}
      >
        <div>
          <DetailHeader>
            <DetailDate fontSize={1}>
              <span>{date}</span>
              <span> - </span>
              <span>{startHour} a {endHour}</span>
            </DetailDate>

            <DetailDate fontSize={1}><span>{data.Location}</span></DetailDate>

            <DetailTitle fontSize={[2, 3]}>{data.Name}</DetailTitle>
            <DetailType>{data.Type}</DetailType>
          </DetailHeader>

          <DetailDescription>
            {data.Description}
          </DetailDescription>

          <Section>
            <h3><Trans>Sub actividades</Trans></h3>
            <Timeline>
              {subActivities.map((subActivity: any) => (
                <Timeline.Item>
                  <SubActivityName>{subActivity.Name}</SubActivityName>
                  <SubActivityDescription>{subActivity.Description}</SubActivityDescription>
                </Timeline.Item>
              ))}
            </Timeline>
          </Section>

          <Section>
            <h3><Trans>Panelistas</Trans></h3>
            <SpeakersWrapper>
              {speakers.map((s: any) => (
                <SpeakerBadge
                  imageURL={s.PhotoURL ? s.PhotoURL : DefaultAvatar}
                  name={`${s.FirstNames} ${s.LastNames}`}
                  biography={s.Biography}
                />
              ))}
            </SpeakersWrapper>
          </Section>

          {this.renderCustomComponent()}
        </div>
      </Modal>
    )
  }

  renderCustomComponent () {
    const { customRender } = this.props

    if (customRender) {
      return (
        <CustomComponentWrapper>
          {customRender()}
        </CustomComponentWrapper>
      )
    }
  }
}

// Detail styles

const DetailHeader = styled.div`
  padding-bottom: 32px;
  border-bottom: 1px solid #eaeaea;
`

const DetailDate = styled.p<FontSizeProps>`
  text-align: center;
  margin: 0;

  ${fontSize}
`

const DetailTitle = styled.h1<FontSizeProps>`
  text-align: center;
  font-weight: 400;
  margin: 0;

  ${fontSize}
`

const DetailType = styled.p<FontSizeProps>`
  text-align: center;
  color: #5A87CD;
  margin: 0;

  ${fontSize}
`

const DetailDescription = styled.p`
  text-align: justify;
  padding-top: 32px;
`

const Section = styled.div`
  padding-top: 32px;

  h3 {
    margin-bottom: 16px;
  }
`

const SubActivityName = styled.p`
  margin: 0;
`

const SubActivityDescription = styled.p`
  color: #5A87CD;
  margin: 0;
`

const CustomComponentWrapper = styled.div`
  margin-top: 20px;
  text-align: right;
`

const SpeakersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

`
